import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GoogleTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;

    window.gtag("config", "AW-18060874869", {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null;
};

export default GoogleTracker;
